import { BmHttp } from "../utils/Global";


export const ListarTiposSeguros = async (idclinica) => {
    try {
        const {data} = await BmHttp().get("listar_tipo_seguro?idclinica="+idclinica);
        return data;
    } catch (error) {
        console.error(error);
    }
}
// Service.Plan.js o Service.Plan.ts
// CONFIG-PLANES-SEGURO-31: por defecto el backend devuelve solo planes Activos.
// `opts.incluirPlanId` añade el plan histórico ya asignado al paciente aunque
// esté inactivo; `opts.estado="Todos"` desactiva el filtro.
export const ListarPlanesPorSeguro = async (seguro_id, opts = {}) => {
    try {
      const params = new URLSearchParams({ seguro_id: String(seguro_id) });
      if (opts.incluirPlanId !== undefined && opts.incluirPlanId !== null && opts.incluirPlanId !== "") {
        params.set("incluir_plan_id", String(opts.incluirPlanId));
      }
      if (opts.estado) params.set("estado", opts.estado);
      const {data} = await BmHttp().get("listar_tipo_seguro_plan?" + params.toString());
      return data;
    } catch (error) {
        console.error(error);
    }
  };
  